import { injectable } from "inversify";
import SERVICE_IDENTIFIER from "../../wires/Identifiers";
import { IApiService } from "./ApiService";
import * as apis from '../../constants/ApiUrlConstants'
import IoCContainer from '../../wires/Bootstrapper';
import { IMenuModel } from "../../models/MenuItems";

export interface IAppLayoutService {
    getMenuForRoute(): Promise<IMenuModel | any>;
}

@injectable()
export class AppLayoutService implements IAppLayoutService {

    apiClient: IApiService;

    public constructor() {
        this.apiClient = IoCContainer.get(SERVICE_IDENTIFIER.API_SERVICE);
    }

    ///AA recupera la lista di rotte di cui l'utente dispone l'autorizzazione
    async getMenuForRoute() {
        return this.apiClient.getAsync<IMenuModel>(apis.GetRoutes, null);
    }
}